module.exports = __webpack_public_path__ + "img/logo-mobile.324d4ea4.png";